import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { StatsActiveDevicesCountResponseDto } from '../types/dtos/stats.dto';
import { BaseService } from './base.service';
import { WebsocketService } from './websocket.service';

@Injectable({
  providedIn: 'root',
})
export class StatsService extends BaseService {

  private _activeDevicesCount: number | null = null;

  constructor(
    private readonly _httpClient: HttpClient,
  ) {
    super();
    this.fetchActiveDevicesCount();
  }

  public getActiveDevicesCount(): number | null {
    return this._activeDevicesCount;
  }

  public fetchActiveDevicesCount(): void {
    this._httpClient.get<StatsActiveDevicesCountResponseDto>(`${ this._baseUrl }/stats/activeDevices`)
      .pipe(take(1))
      .subscribe({
        next: (result: StatsActiveDevicesCountResponseDto) => {
          this._activeDevicesCount = result.data.count ?? null;
        },
      });
  }
}
